/* =============================================================
   Layout.jsx — Admin portal page shell
   -------------------------------------------------------------
   Wraps every admin screen with the sidebar, fixed top header,
   and the main content area. The content area shifts right
   automatically when the sidebar expands or collapses.
   ============================================================= */

import Sidebar from './Sidebar';
import Header  from './Header';
import { useSidebar } from '../context/SidebarContext';


export default function Layout({ children }) {
  const { open } = useSidebar();

  return (
    <div className="min-h-screen bg-[#f8f9ff]">
      <Sidebar />
      <Header />
      <main
        className="pt-16 min-h-screen transition-all duration-300"
        style={{ marginLeft: open ? '280px' : '72px' }}
      >
        <div className="p-10">
          {children}
        </div>
      </main>
    </div>
  );
}
